/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { useTranslate } from "@adapptio/lib-components";
import { IInspectorControlEnumProps } from "./InspectorControlEnum.common";
import { useEditorInspectorContext } from "../../../ui/contexts/EditorInspectorContext";
import { InvalidModelNode } from "../../../ui/components/Inspector/InvalidModelNode";
import { FieldButton, FieldGroup } from "@adapptio/lib-editor-ui";

export const InspectorControlEnum_Buttons: React.FC<IInspectorControlEnumProps> = ({ model }) => {
	const t = useTranslate();
	const editorInspectorCtx = useEditorInspectorContext();

	const handleChange = useCallback(
		(value: string | number) => {
			if (!model) {
				return;
			}

			model.schema.setValue(model, value, true);
		},
		[ model ]
	);

	if (!model) {
		return <InvalidModelNode model={model} />;
	}

	const schema = model.schema;

	return (
		<FieldGroup preventTruncate>
			{schema.opts.options.map((option) => {
				return (
					<FieldButton
						key={option.value}
						icon={option.icon}
						tooltip={option.icon ? t("editor", option.label) : undefined}
						selected={model.value === option.value}
						onClick={() => handleChange(option.value)}
						readOnly={editorInspectorCtx?.readOnly}
					>
						{!option.icon ? t("editor", option.label) : null}
					</FieldButton>
				);
			})}
		</FieldGroup>
	);
};
